import { z } from 'zod';

export const ImageObjectSchema = z.object({
	url: z.string(),
	altText: z.string().nullable(),
	length: z.number(),
	mimeType: z.string(),
});